import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';
import '@mantinex/mantine-header/styles.css';
import 'mantine-datatable/styles.css';

import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { AuthProvider } from './providers/auth/AuthProvider';
import { OAuthProvider } from './providers/auth/OAuthProvider';
import { IdentityProvider } from './providers/identity/IdentityProvider';
import { PreferenceProvider } from './providers/preference/PreferenceProvider';
import { SettingProvider } from './providers/setting/SettingProvider';
import { Router } from './routes/Router';
import { theme } from './theme';

export default function App() {
    return (
        <PreferenceProvider>
            <AuthProvider>
                <OAuthProvider>
                    <IdentityProvider>
                        <SettingProvider>
                            <MantineProvider theme={theme}>
                                <ModalsProvider>
                                    <Notifications />
                                    <Router />
                                </ModalsProvider>
                            </MantineProvider>
                        </SettingProvider>
                    </IdentityProvider>
                </OAuthProvider>
            </AuthProvider>
        </PreferenceProvider>
    );
}
